'use strict';

module.exports = 9007199254740991;